import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { SUB_TYPE, USER_TYPE } from 'src/app/core/Constants/static';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  activeTab: number = 1;
  systemAdmin: boolean = false;
  user?: UserDetails;
  public subTypes = SUB_TYPE
  public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;
  @ViewChildren('focusedElement') focusedElement!: QueryList<any>;
  constructor(
    private userService: UserService
  ) {
    this.user = this.userService.getUserInfo()?.userDetails;
  }

  ngOnInit(): void {
    this.userType;
    if (this.checkPermission('getProvider')) {
      this.activeTab = 1;
    } else {
      this.activeTab = 2;
    }
  }
  focusFn() {
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);

  }
  get userType() {
    // this.user?.userType === USER_TYPE.payer && 
    this.systemAdmin = this.user?.userType === USER_TYPE.system ? true : false;
    if (this.checkPermission('getPayer') && this.subTypeEvm == this.subTypes.payer) {
      this.activeTab = 2;
      return 'Payers'
    } else if (this.checkPermission('getProvider') && this.subTypeEvm == this.subTypeEvm.provider ) {
      // this.user?.userType === USER_TYPE.provider && 
      this.activeTab = 1;
      return 'Providers'
    } else if(this.subTypeEvm == this.subTypeEvm.both ) {
      
      if (this.checkPermission('getPayer') && !this.checkPermission('getProvider')) {
        return 'Payers'
      }
      else if (!this.checkPermission('getPayer') && this.checkPermission('getProvider')) {
        return 'Providers'
      } else {
        return 'Providers/Payer'
      }

    }
    return '';
  }
  switchTab(tab: number) {
    this.activeTab = tab;
  }

  checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

}
